export type InterfaceListingFilter = {
    filter_type: InterfaceFilterTypes,
    tag?: string,
    title: string,
    parentTitle?: string,
    id?: string,
    filter_value?: any,
    filter_value_type: InterfaceFilterValueType,
    asyncSearchSchema?: string,
    asyncSearchField?: string,
    mode?: "single"|"multiple"|"tags",
    placeholder?: string,
    minChars?: number,
    delay?: number,
    closeOnSelect?: boolean,
    filterResults?: boolean,
    resolveOnLoad?: boolean,
    showNoResults?:boolean,
    showNoOptions?:boolean,
    noOptionsText?: string,
    noResultsText?: string,
    searchable?: boolean,
    async?: boolean,
    options?: any,
    fetchOptionsSchema?: string,
    fetchFilterName?: string,
    clearedValue?: InterfaceFilterDefaultValueType,
    urlFilterName?: string,
    dateTypeValue?: string|undefined,
    dateRangeValue?: Array<Date>|undefined
    getFilterParam?:string,
    delimiter?:string,
    isApiSourceStatusFilter?:boolean,
    apiSourceId?:number,
    showNever?: boolean,
}

export enum InterfaceFilterTypes {
    DATES,
    MULTISELECT,
    SEARCH,
    MONTH_DATES,
}

export enum InterfaceFilterValueType {
    VALUE_DATE,
    VALUE_ARRAY,
    VALUE_STRING,
}

export enum InterfaceFilterSchema {
    TMS_ROAD_DOMESTIC = "domestic-shipments",
    TMS_ROAD_INTERNATIONAL = "international-shipments",
    TMS_SEA = "tms-sea-shipments",
    TMS_AIR = "tms-air-shipments",
    WMS_ORDERS = "outbounds",
    WMS_RECEPTIONS = "inbounds",
    VBS_ORDERS = "vbs-report-outbounds",
    VBS_RECEPTIONS = "vbs-report-inbounds",
    ERP_CLIENTS = "customer-ledger-entries",
    STRONGO_SHIPMENTS = "strongo-shipments"
}

export enum InterfaceFilterDefaultValueType {
    DEFAULT_EMPTY_STRING,
    DEFAULT_EMPTY_ARRAY,
    DEFAULT_NULL,
    DEFAULT_UNDEFINED,
}

export enum InterfaceFilterMultipleSeparator {
    SEPARATOR = '///',
}